/**
 * Coordinate conversion utilities for flight planning calculations.
 * Provides approximate lat/lng ↔ meters conversions using spherical Earth model.
 *
 * Accuracy note: These approximations are sufficient for areas < a few km².
 * For larger areas or high-latitude operations, consider WGS84 ellipsoid math.
 */

// Approximate meters per degree of latitude (constant at all latitudes).
// Standard geodetic value for a spherical Earth (verified).
export const LAT_TO_METERS = 110540;

// Base meters per degree of longitude at the equator (verified).
export const LNG_TO_METERS_BASE = 111320;

// 35mm full-frame sensor diagonal in mm (used for crop factor calculation).
// Derived from √(36² + 24²) = 43.27 mm (standard full-frame dimensions).
export const FULL_FRAME_DIAGONAL_MM = 43.27;

/**
 * Calculate meters per degree of longitude at a given latitude.
 * Longitude degrees shrink toward the poles.
 * @param {number} lat - Latitude in degrees
 * @returns {number} Meters per degree of longitude
 */
export const lngToMetersAtLat = lat => LNG_TO_METERS_BASE * Math.cos((lat * Math.PI) / 180);
